import * as React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { merge, css } from "glamor";
import SearchableCompanyInfiniteListView from "containers/searchable-companies";
import Toggle from "material-ui/Toggle";

import theme from "styles/theme";
import { format } from "lib/globalize-util";
import { DATATEST } from "constants/integration";
import { resetProductInsights } from "actions/insights";

interface IProps {
    me: any;
    open: boolean;
    viewAs: string;
    onToggleViewAsGuest: () => void;
    viewAsGuest: boolean;
    showViewAsGuest: boolean;
    scope: any;
    onSetViewAs: (company) => void;
    showSearch: boolean;
    hideMsrp: boolean;
    onToggleHideMsrp: () => void;
    hideWholesale: boolean;
    onToggleHideWholesale: () => void;
    isBuyerWithSingleCompany: boolean;
}

interface DispatchProps {
    resetProductInsights: () => void;
}

class ViewAsDropdown extends React.PureComponent<DispatchProps & IProps> {
    private styles = {
        base: {
            position: "absolute",
            display: "block",
            top: "100%",
            right: 0,
            width: "320px",
            maxWidth: "320px",
            background: "white",
            maxHeight: "0px",
            opacity: 0,
            zIndex: 12,
            transition: "all .3s ease-in",
            overflowX: "hidden",
            overflowY: "hidden",
            boxShadow: "0px 4px 12px rgba(0,0,0,.4)",
            "@media(max-width: 590px)": {
                right: "-80px",
                width: "270px",
            },
        },
        open: {
            maxHeight: "580px",
            opacity: 1,
        },
        clear: {
            background: "#f8f8f8",
            margin: "0",
            padding: "8px 12px",
            fontSize: "14px",
            display: "block",
            lineHeight: "18px",
        },
        label: {
            display: "block",
            position: "relative" as any,
            width: "100%",
            margin: "0px",
            padding: "12px 14px 0",
        },
        title: {
            fontSize: "24px",
            padding: "8px 0",
            margin: "0px",
            color: theme.palette.darkestGrey,
        },
        checkboxBorderBottom: {
            marginBottom: "16px",
            paddingBottom: "8px",
            borderBottom: `1px solid ${theme.palette.lighterGrey}`,
        },
        checkbox: {
            marginBottom: "16px",
        },
        placeholder: {
            fontSize: "12px",
            color: theme.palette.darkGrey,
            textAlign: "justify",
            padding: "0 0 10px",
        },
        marginTop: {
            marginTop: "16px",
        },
    };

    render() {
        const {
            me,
            open,
            viewAs,
            onToggleViewAsGuest,
            viewAsGuest,
            showViewAsGuest,
            scope,
            onSetViewAs,
            showSearch,
            hideWholesale,
            hideMsrp,
            isBuyerWithSingleCompany,
        } = this.props;
        const isBuyer = me.account_type === "buyer";
        const canHidePricing = !!me.hasPermission("can_hide_pricing");

        return (
            <div {...merge(this.styles.base, open && this.styles.open)}>
                {viewAs && !isBuyer && (
                    <div>
                        <a style={this.styles.clear} href="#" onClick={this.handleClear}>
                            {format("Clear View As")}
                        </a>
                    </div>
                )}

                <div style={this.styles.label} onClick={this.handlePreventDefault}>
                    <h3 {...css(this.styles.title)}>{format("View As")}</h3>

                    {!isBuyerWithSingleCompany && (
                        <div {...css(this.styles.placeholder)}>
                            {isBuyer
                                ? format("You belong to multiple companies. Select the company you want to browse as.")
                                : format(
                                      "Shop around like the customer. Search for the customer you want to browse as below."
                                  )}
                        </div>
                    )}

                    {showViewAsGuest && !isBuyer && (
                        <div>
                            <Toggle
                                toggled={viewAsGuest}
                                labelPosition="right"
                                label={format("Shop as Guest Buyer")}
                                style={this.styles.checkboxBorderBottom}
                                onToggle={onToggleViewAsGuest}
                            />
                        </div>
                    )}

                    {canHidePricing && (
                        <div style={viewAs ? null : this.styles.marginTop}>
                            <Toggle
                                toggled={hideMsrp}
                                labelPosition="right"
                                label={format("Hide MSRP")}
                                data-test={DATATEST.VIEW_AS_PANEL.HIDE_MSRP}
                                style={this.styles.checkbox}
                                onToggle={this.handleToggleHideMsrp}
                            />
                        </div>
                    )}
                    {canHidePricing && (
                        <div>
                            <Toggle
                                toggled={hideWholesale}
                                labelPosition="right"
                                label={format("Hide Wholesale Price")}
                                data-test={DATATEST.VIEW_AS_PANEL.HIDE_WHOLESALE}
                                style={this.styles.checkboxBorderBottom}
                                onToggle={this.handleToggleHideWholesale}
                            />
                        </div>
                    )}

                    {!isBuyerWithSingleCompany && !viewAsGuest && (
                        <SearchableCompanyInfiniteListView
                            scope={scope}
                            showSearch={showSearch}
                            onSelect={onSetViewAs}
                            selectedCompany={_.get(scope.company, "_id")}
                        />
                    )}
                </div>
            </div>
        );
    }

    private handleToggleHideMsrp = () => this.props.onToggleHideMsrp();
    private handleToggleHideWholesale = () => this.props.onToggleHideWholesale();

    private handleClear = (e) => {
        e.preventDefault();
        this.props.onSetViewAs(undefined);
        this.props.resetProductInsights();
    };

    private handlePreventDefault(e) {
        e.stopPropagation();
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetProductInsights: () => dispatch(resetProductInsights()),
    };
};

export const ViewAsDropdownContainer = connect<null, DispatchProps, IProps>(null, mapDispatchToProps)(ViewAsDropdown);
export default ViewAsDropdownContainer;
